const CharacterSet = 'ABCDFGHJKMNPQRSTUVWXYZ';
const charLength = CharacterSet.length;

const codePointFromCharacter = (character: string) => CharacterSet.indexOf(character);
const characterFromCodePoint = (codePoint: number) => CharacterSet.charAt(codePoint);

export const generateCheckCharacter = (rawInput: string) => {
  const input = rawInput.toUpperCase();
  let factor = 2;
  let sum = 0;

  // Starting from the right and working leftwards is easier since
  // the initial "factor" will always be "2".
  for (let i = input.length - 1; i >= 0; i--) {
    const codePoint = codePointFromCharacter(input.charAt(i));
    let addend = factor * codePoint;

    // Alternate the "factor" that each "codePoint" is multiplied by
    factor = factor === 2 ? 1 : 2;
    // Sum the digits of the "addend" as expressed in base "n"
    addend = Math.floor(addend / charLength) + (addend % charLength);
    sum += addend;
  }

  // Calculate the number that must be added to the "sum"
  // to make it divisible by "charLength".
  const remainder = sum % charLength;
  const checkCodePoint = (charLength - remainder) % charLength;

  return characterFromCodePoint(checkCodePoint);
};

export const validateCheckCharacter = (rawInput: string) => {
  const input = rawInput.toUpperCase();

  // Any character outside the known set would map to code point -1 and
  // silently corrupt the checksum, so reject such input up front.
  if (![...input].every((character) => codePointFromCharacter(character) >= 0)) {
    return false;
  }

  let factor = 1;
  let sum = 0;

  // Starting from the right, work leftwards
  // Now, the initial "factor" will always be "1"
  // since the last character is the check character.
  for (let i = input.length - 1; i >= 0; i--) {
    const codePoint = codePointFromCharacter(input.charAt(i));
    let addend = factor * codePoint;

    // Alternate the "factor" that each "codePoint" is multiplied by
    factor = factor === 2 ? 1 : 2;
    // Sum the digits of the "addend" as expressed in base "charLength"
    addend = Math.floor(addend / charLength) + (addend % charLength);
    sum += addend;
  }

  const remainder = sum % charLength;

  return remainder === 0;
};
